import type { ReactNode } from "react";
import { Pill } from "@championcare/ui";

export function Loading({ label = "Loading…" }: { label?: string }) {
  return <div className="state state--loading">{label}</div>;
}
export function ErrorState({ message }: { message: string }) {
  return <div className="state state--error">{message}</div>;
}
export function EmptyState({ children }: { children: ReactNode }) {
  return <div className="state state--empty">{children}</div>;
}

const STATUS_TONE: Record<string, "default" | "gold" | "blood"> = {
  live: "blood",
  scheduled: "default",
  confirmed: "default",
  completed: "default",
  cancelled: "default",
  no_show: "default",
};
export function StatusPill({ status }: { status: string }) {
  return <Pill variant={STATUS_TONE[status] ?? "default"}>{status.replace("_", " ")}</Pill>;
}

export function PageHeader({ title, sub }: { title: string; sub?: string }) {
  return (
    <header className="page-head">
      <h1 className="page-head__title">{title}</h1>
      {sub && <p className="page-head__sub">{sub}</p>}
    </header>
  );
}

export function StatCard({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="stat">
      <div className="stat__label">{label}</div>
      <div className="stat__value">{value}</div>
    </div>
  );
}
